import { Option } from '@sapphire/result';
import {
  InsightsChildState,
  InsightsState,
} from '../survey-creation-insights-state.model';
import { DEFAULT_CHILD_INSIGHTS_STATE } from '../survey-creation-insights-state.constants';
import { SurveyChildKey } from '../../survey-creation-shared-state.model';

export type InsightsChildPatch =
  | Partial<InsightsChildState>
  | ((child: InsightsChildState) => Partial<InsightsChildState>);

export function selectActiveInsightsChild(
  state: InsightsState,
): InsightsChildState {
  return Option.from(state.activeChildId)
    .andThen((key) => Option.from(state.children[key]))
    .unwrapOr(DEFAULT_CHILD_INSIGHTS_STATE);
}

export function patchActiveInsightsChild(
  state: InsightsState,
  patch: InsightsChildPatch,
): InsightsState {
  return Option.from(state.activeChildId).match({
    some: (key) => {
      const child = selectActiveInsightsChild(state);
      const patchFor = typeof patch === 'function' ? patch : () => patch;

      return {
        ...state,
        children: {
          ...state.children,
          [key]: { ...child, ...patchFor(child) },
        },
      };
    },
    none: () => state,
  });
}

export function patchPreDraftInsightsChild(
  state: InsightsState,
  key: SurveyChildKey,
  patch: InsightsChildPatch,
): InsightsState {
  const child = state.children[key] ?? DEFAULT_CHILD_INSIGHTS_STATE;
  const patchFor = typeof patch === 'function' ? patch : () => patch;

  return {
    ...state,
    children: {
      ...state.children,
      [key]: { ...child, ...patchFor(child) },
    },
  };
}
